import React, {useRef} from 'react'

import Task from "../../../model2/task/task"
import MoveManger from "../../../gd/manager/move-manager"
import {TASK_RECURRENCE} from "../../../model2/recurrence/const"
import PopoverMenuOption from "../../../gd-components/popover-menu/popover-menu/menu-option"
import {PopoverMenuItemType} from "../../../gd-components/popover-menu/popover-menu/const"
import PopoverMenuSeparator from "../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import ItemId from "../../id/item-id"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../gd-components/buttons/control-button/control-button-standard"
import taskView_getTimerOptions from "../../../../item-view/task/components/timer-new/get-timer-options"
import PopoverMenuOptionWithSubmenu
    from "../../../gd-components/popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import PopoverMenuOptionWithCustomPopover
    from "../../../gd-components/popover-menu/popover-menu/option-with-custom-popover/menu-option-with-custom-popover";
import TaskStatusManager from "../../../gd/manager/task-status-manager";
import TaskMoreMenuStatus from "../../select-status/task_v2/render/more-menu-status";
import StatusIcon from "./components/status-icon";
import Pin from "../../../gd-components/pin/v2/pin"
import taskMore_getMoveOptions from "./functions/get-move-options"

type Props = {
    task                : Task

    disabledActions?    : string[]
    customOptions?      : any[]

    showOpen?           : boolean
    hideMove?           : boolean

    hidePopover         : func

    onMove?             : func  // not in use po hodu
    onDelete?           : func

    // for future not in use at the moment - i.e. lock dates in gant view
    onLockDates?        : func
    onUnlockDates?      : func
}

export default function TaskMorePopoverMenu(props: Props) {

    // Validate data for task more popover
    props.task.checkDataForMorePopover()

    const selfRef: any = useRef()

    /*const onClickOpen = () => {
        gd.taskView.open(props.task.id)
    }

    const onClickOpenNewWindow = () => {
        window.open("/t/"+props.task.id)
    }*/

    /*const onClickPin = () => {
        props.hidePopover()
    }*/

    const onClickCopyLink = () => {
        props.hidePopover()
        props.task.copyUrl()
    }

    const onClickMinimizeToTRay = () => {
        props.hidePopover()
        props.task.minimizeToTRay()
    }

    const onClickOpenNewWindow = () => {
        props.hidePopover()
        props.task.openNewWindow()
    }

    const onClickRename = () => {
        props.hidePopover()
        props.task.rename()
    }

    const onClickLockDates = () => {
        if (props.onLockDates) props.onLockDates()
    }

    const onClickUnlockDates = () => {
        if (props.onUnlockDates) props.onUnlockDates()
    }

    const onClickConvert = () => {
        gd.modals.task.convertTaskType(props.task, (taskType, taskStatus)=>{
            const data: any = {
                id          : props.task.id,
                taskTypeId  : taskType
            }
            if (taskStatus) data.statusId = taskStatus

            // if (props.onEdit) props.onEdit(data)

        })
    }

    const onClickPro = () => {
        gd.modals.other.upgradeToPro(gd.companyId)
    }

    const onClickRecurrence = () => {
        const taskId = props.task.recurrency ? props.task.recurrency.parentTaskId : props.task.id
        gd.modals.other.recurrence(TASK_RECURRENCE, taskId)
    }

    const onClickRemindMe = () => {
        gd.modals.task.createReminder(props.task, gd.user.id)
    }

    const onClickCopy = () => {
        gd.modals.task.duplicate(props.task, ()=>{
        }, {redirectToCopy: false})
    }

    const onClickDelete = () => {
        gd.modals.task.deleteTask(props.task, (data:any)=>{
            if (!(data && data.hasOwnProperty("deleteInProgress")) && props.onDelete) props.onDelete();
        })
    }

    let menuOptions = []

    const project           = gd.session.projects.get(props.task.projectId ? props.task.projectId : props.task.parentId);
    const isTemplate        = project ? project.isTemplate : false;
    const isFullAccess      = gd.ac.check.project.fullAccess(props.task.projectId);
    const isStandardAccess  = gd.ac.check.project.standardAccess(props.task.projectId);

    // const disableDeleteButton       = project ? !gd.ac.check.task.canDelete(project.id) : true;
    const disabledDuplicateButton   = !props.task.acl.canDuplicate || props.disabledActions?.includes('duplicate')

    // init taskSystemType
    const taskSystemType = _.get(props.task, 'systemType', gd.const.task.systemType.TASK)

    const disableRename = !props.task.acl.canRename

    menuOptions.push({
        icon        : "i5-pen",
        label       : "Rename",
        disabled    : disableRename,
        onClick     : onClickRename,
    })

    //currently for gantt only
    if (isFullAccess) {
        if (props.onLockDates) {
            menuOptions.push({
                icon    : "i5-lock",
                label   : "Lock dates",
                onClick : onClickLockDates,
            })
        } else if (props.onUnlockDates) {
            menuOptions.push({
                icon    : "i5-lock",
                label   : "Unlock dates",
                onClick : onClickUnlockDates,
            })
        }
    }

    if (!props.hideMove) {
        const moveDisabled = isTemplate || props.disabledActions?.includes('move') || !props.task.acl.canMove
        menuOptions.push({
            type        : PopoverMenuItemType.POPOVER,
            icon        : 'i5-move',
            label       : 'Move to',
            options     : taskMore_getMoveOptions(props.task, props.hidePopover, props.onMove),
            disabled    : moveDisabled,
        })
    }


    menuOptions.push({
        icon        : "i5-task-types",
        label       : "Change task type",
        onClick     : onClickConvert,
        disabled    : props.disabledActions?.includes('change-type') || !props.task.acl.canChangeType,
    })

    const currentStatus = gd.session.statuses.get(props.task.statusId);

    const canChangeStatus = props.task.acl.canChangeStatus
    menuOptions.push({
        type                : PopoverMenuItemType.COMPONENT,
        iconComponent       : <StatusIcon currentStatus={currentStatus} className={Classes("m-r-8", {'is-disabled': !canChangeStatus})}/>,
        label               : 'Status',
        menuComponent       : TaskMoreMenuStatus,
        menuParams          : {
            task                : props.task,
            workflow            : TaskStatusManager.getWorkflow(props.task),
            hint                : true,
            classes             : "min-w-200",
            togglePopover       : props.hidePopover
        },
        disabled            : !canChangeStatus,
    })

    menuOptions.push({ type: PopoverMenuItemType.SEPARATOR})

    menuOptions.push({
        type        : PopoverMenuItemType.POPOVER,
        icon        : 'i5-time-reported',
        label       : 'Time tracking',
        options     : taskView_getTimerOptions(props.task, props.hidePopover),
        disabled    : !props.task.acl.canAddTimeTracking,
    })

    menuOptions.push({
        icon        : "i5-notification",
        label       : "Remind me",
        onClick     : onClickRemindMe,
        disabled    : !props.task.acl.canAddReminder,
    })

    menuOptions.push({ type: PopoverMenuItemType.SEPARATOR})

    // duplicate
    menuOptions.push({
        icon        : "i5-clone",
        label       : "Duplicate",
        disabled    : disabledDuplicateButton,
        onClick     : !gd.company.license.isPro ? onClickPro : onClickCopy,
        isPro       : !gd.company.license.isPro
    })

    // recurring

    const recurrenceDisabled = isTemplate || props.disabledActions?.includes('recurring') || !props.task.acl.canAddRecurrence
    if (!gd.company.license.isPro) {
        menuOptions.push({
            icon        : "i5-recurrence",
            label       : "Make recurring",
            onClick     : onClickPro,
            disabled    : recurrenceDisabled,
            isPro       : true
        })
    } else {
        if (props.task.recurrency) {
            menuOptions.push({
                icon        : "i5-recurrence",
                label       : "Edit recurrence",
                onClick     : onClickRecurrence,
                disabled    : recurrenceDisabled
            })
        } else {

            if (gd.const.systemStatus.isOpen(props.task.systemStatus)) {
                menuOptions.push({
                    icon        : "i5-recurrence",
                    label       : "Make recurring",
                    onClick     : onClickRecurrence,
                    disabled    : recurrenceDisabled
                })
            } else {
                menuOptions.push({
                    icon        : "i5-recurrence",
                    label       : "Make recurring",
                    onClick     : onClickRecurrence,
                    disabled    : true
                })
            }
        }
    }

    menuOptions.push({ type: PopoverMenuItemType.SEPARATOR})

    // DELETE
    menuOptions.push({
        icon        : "i5-trash-alt",
        label       : "Delete",
        disabled    : !props.task.acl.canDelete || props.disabledActions?.includes('delete'),
        onClick     : onClickDelete
    })

    if (props.customOptions) {
        menuOptions.push({ type: PopoverMenuItemType.SEPARATOR})
        menuOptions = menuOptions.concat(props.customOptions);
    }

    return (
        <div ref={selfRef} className="ui5-popover-menu min-w-275">
            <div className="flex-row-between-center h-36 m-t-5 p-l-20 p-r-10">
                <ItemId itemId      = {props.task.shortId}
                        itemUrl     = "t/"
                        itemUrlId   = {props.task.id}
                        itemName    = "Task"
                        copyId      = {true}
                        copyUrl     = {true}/>

                <div className="flex-row-center-center">
                    <Pin data={{taskId: props.task.id}}/>

                    <ControlButtonStandard className    = "m-l-5"
                                           type         = {ControlButtonType.LINK}
                                           hint         = "Copy link"
                                           onClick      = {onClickCopyLink}/>
                    <ControlButtonStandard className    = "m-l-5"
                                           type         = {ControlButtonType.TRAY}
                                           hint         = "Move task to tray"
                                           onClick      = {onClickMinimizeToTRay}/>
                    <ControlButtonStandard className    = "m-l-5"
                                           type         = {ControlButtonType.OPEN_IN_BROWSER}
                                           hint         = "Open in new window"
                                           onClick      = {onClickOpenNewWindow}/>
                </div>
            </div>

            {_.map(menuOptions, (menuOption: any, key) => {
                if (menuOption.type === PopoverMenuItemType.SEPARATOR) {
                    return <PopoverMenuSeparator key={key}/>
                }

                if (menuOption.type === PopoverMenuItemType.POPOVER) {
                    return <PopoverMenuOptionWithSubmenu key                =   {key}
                                                         showMenuSelection  =   {false}
                                                         option             =   {menuOption}/>
                }

                if (menuOption.type === PopoverMenuItemType.COMPONENT) {
                    return <PopoverMenuOptionWithCustomPopover key          =   {key}
                                                               menuParams   =   {menuOption.menuParams}
                                                               option       =   {menuOption}/>
                }

                return <PopoverMenuOption key           =   {key}
                                          option        =   {menuOption}
                                          checkPro      =   {menuOption.isPro}
                                          hidePopover   =   {props.hidePopover}/>
            })}
        </div>
    )
}
